import { formatCurrency, formatRentPrice } from '$utilities/data';
import { useExchangeRate } from '$contexts/exchange-rate';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/properties.d.ts').PropertyPriceText}
 */
export const PropertyPriceText = ({
    isOffMarket,
    pageType,
    prefix = '',
    price,
    priceCurrency,
    priceRentPeriod,
    secondPrice,
    priceTypeLabel,
    suffix = '',
}) => {
    const { currency, convertToCurrency } = useExchangeRate() || {};

    if (isOffMarket) { return null; }

    if (priceTypeLabel === 'Price On Application') { return 'P.O.A.'; }

    let formattedPrice = '';
    if (price > 0) {
        const convertedPrice = currency ? convertToCurrency({ from: priceCurrency || 'GBP',
            to: currency,
            amount: price }) : price;
        const convertedSecondPrice = currency ? convertToCurrency({ from: priceCurrency || 'GBP',
            to: currency,
            amount: secondPrice }) : secondPrice;
        switch (pageType) {
            case 'SalePropertyDetailPage':
                formattedPrice = formatCurrency(convertedPrice, currency || priceCurrency || 'GBP');
                if (convertedSecondPrice) {
                    formattedPrice += ` – ${formatCurrency(convertedSecondPrice, currency || priceCurrency || 'GBP')}`;
                }
                break;
            case 'RentalPropertyDetailPage':
                formattedPrice = formatRentPrice(convertedPrice, currency || priceCurrency || 'GBP', priceRentPeriod);
                if (convertedSecondPrice) {
                    formattedPrice = formatRentPrice(convertedPrice, currency || priceCurrency || 'GBP', priceRentPeriod, { includeSuffix: false });
                    formattedPrice += ` – ${formatRentPrice(convertedSecondPrice, currency || priceCurrency || 'GBP', priceRentPeriod)}`;
                }
                break;
        }
    }
    if (priceTypeLabel === 'From') { prefix = 'From: '; }

    return prefix + formattedPrice + suffix;
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default PropertyPriceText;
